import { isPlatformBrowser } from '@angular/common';
import { HttpEventType } from '@angular/common/http';
import { Component, Inject, OnInit, Optional, PLATFORM_ID } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import readXlsxFile from 'read-excel-file';
import { firstValueFrom, Subscription } from 'rxjs';
import { ModalObjectType } from 'src/app/interfaces/modal-object-types.interface';
import { TransferStoreWorkshopDetailImportModel } from 'src/app/models/imports/transfer-store-workshop-detail-import';
import { LoadPreInvoicingModel } from 'src/app/models/invoicing/load-preinvoicing.models';
import { PreInvoicingAlertModel } from 'src/app/models/invoicing/pre-invoicing-alert.models';
import { TransferStoreWorkshopDetailService } from 'src/app/services/maintenance/transfer-store-workshop-detail.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';

@Component({
  selector: 'app-import-transfer-store-workshop-detail',
  templateUrl: './import-transfer-store-workshop-detail.component.html',
  styleUrls: ['./import-transfer-store-workshop-detail.component.scss'],
  standalone: false
})
export class ImportTransferStoreWorkshopDetailComponent implements OnInit {

  eventFile: any;
  errorTransfer: number = 0;
  loadPreInvoicingModel: LoadPreInvoicingModel = new LoadPreInvoicingModel();
  nameFile: string = '';
  subscription: Subscription;
  transferAlerts: Array<PreInvoicingAlertModel> = new Array<PreInvoicingAlertModel>;
  transferStoreWorkshopDetailImport: boolean = false;
  transferStoreWorkshopId: number = 0;
  visibleTxt: boolean = false;

  constructor(public config: DynamicDialogConfig,
    private toastHandlerService: ToastHandlerService,
    private transferStoreWorkshopDetailService: TransferStoreWorkshopDetailService,
    @Optional() private ref: DynamicDialogRef,
    @Inject(PLATFORM_ID) private platformId: object) { }

  async ngOnInit() {
    const input$ = this.config.data?.inputs$;
    if (!input$) {
      console.error('inputs$ no está definido en config.data');
      return;
    }
    this.subscription = input$?.subscribe((inputs: any) => {
      this.transferStoreWorkshopId = inputs.transferStoreWorkshopId;
    });
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }

  attachFileImport() {
    //validación para ejecutar el código cuando la platafoma de uso sea un navegador
    if (isPlatformBrowser(this.platformId)) {
      document.getElementById('fileImport')?.click();
    }
  }

  clearInputFile() {
    this.nameFile = 'Ningún archivo seleccionado.';
    if (this.eventFile) {
      if (isPlatformBrowser(this.platformId)) {
        this.eventFile.target.value = '';
      }
    }
  }

  close() {
    const data: ModalObjectType = {};
    if (this.transferStoreWorkshopDetailImport) {
      data.params = { reload: true };
      this.ref.close(data);
    } else {
      data.params = { reload: false };
      this.ref.close(data);
    }
  }

  getNameFile(file: any) {
    this.eventFile = file;
    const files = this.eventFile.target.files;
    if (files.length != 0) {
      for (let i = 0; i < files.length; i++) {
        this.nameFile = files[i].name;
      }
    } else {
      this.nameFile = 'Ningún archivo seleccionado.';
    }
  }

  downloadErrorsTxt() {
    if (!this.transferAlerts || this.transferAlerts.length === 0) {
      this.toastHandlerService.showToast('error', 'No hay alertas para exportar');
      return;
    }

    this.transferStoreWorkshopDetailService.exportImportErrors(this.transferAlerts).subscribe({
      next: (blob: Blob) => {
        const file = new Blob([blob], { type: 'text/plain' });
        const url = window.URL.createObjectURL(file);
        const today = new Date();
        const formatDate = today.toISOString().split('T')[0];

        const a = document.createElement('a');
        a.href = url;
        a.download = `ErroresImportacionTopesMaxMin_${formatDate}.txt`;
        a.click();

        window.URL.revokeObjectURL(url);
      },
      error: () => {
        this.toastHandlerService.showToast('error', 'Error al exportar el archivo');
      }
    });
  }

  downloadGuideImport() {
    this.transferStoreWorkshopDetailService.downloadGuideImport().subscribe(data => {
      switch (data.type) {
        case HttpEventType.Response: {
          const downloadedFile = new Blob([data.body!], { type: data.body!.type });
          const a = document.createElement('a');
          a.setAttribute('style', 'display:none;');
          document.body.appendChild(a);
          a.download = "GuiaTrasladoAlmacenTallerDetalles.docx";
          a.href = URL.createObjectURL(downloadedFile);
          a.target = '_blank';
          a.click();
          document.body.removeChild(a);
          break;
        }
      }
    });
  }

  importTransfers() {
    //validación para ejecutar el código cuando la platafoma de uso sea un navegador
    if (isPlatformBrowser(this.platformId)) {
      let isOk: boolean = true;
      const input = document.getElementById("fileImport") as any;
      const rowsImports = new Array<TransferStoreWorkshopDetailImportModel>();
      let row: TransferStoreWorkshopDetailImportModel;
      let counter: number = 1, consecutiveTransferStoreWorkshop: number, articleCode: number, articleName: string, storeCode: number, quantity: number;

      if (input.files[0]) {
        readXlsxFile(input.files[0]).then(async (rows) => {
          if (rows.length <= 1) {
            this.toastHandlerService.showToast('error', 'El archivo ingresado no tiene registros para importar.');
            return;
          }
          rows.splice(0, 1);
          rows.forEach(element => {
            counter = counter + 1;
            let rowHasError = false;

            //A. Consecutivo Traslado:
            const valueTransferConsecutive = element[0];
            if (valueTransferConsecutive == null || valueTransferConsecutive === "") {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna A. El consecutivo del traslado no es válido.`;
              this.transferAlerts.push(alert);
              rowHasError = true;
            }
            consecutiveTransferStoreWorkshop = Number(valueTransferConsecutive);
            if (isNaN(consecutiveTransferStoreWorkshop)) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna A. El consecutivo del traslado no es válido.`;
              this.transferAlerts.push(alert);
              rowHasError = true;
            }

            //B. Código Artículo:
            const valueArticleCode = element[1];
            if (valueArticleCode == null || valueArticleCode === "") {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna B. El código del artículo no es válido.`;
              this.transferAlerts.push(alert);
              rowHasError = true;
            }
            articleCode = Number(valueArticleCode);
            if (isNaN(articleCode)) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna B. El código del artículo no es válido.`;
              this.transferAlerts.push(alert);
              rowHasError = true;
            }

            //C. Nombre Artículo:
            articleName = element[2] as string;
            if (articleName != null && articleName.length > 200) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna C. El nombre del artículo supera el tamaño máximo de caracteres (200).`;
              this.transferAlerts.push(alert);
              rowHasError = true;
            }

            //D. Código Bodega
            const valueStoreCode = element[3];
            if (valueStoreCode == null || valueStoreCode === "") {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna D. El código de la bodega no es válido.`;
              this.transferAlerts.push(alert);
              rowHasError = true;
            }
            storeCode = Number(valueStoreCode);
            if (isNaN(storeCode)) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna D. El código de la bodega no es válido.`;
              this.transferAlerts.push(alert);
              rowHasError = true;
            }

            //E. Cantidad
            const valueQuantity = element[4];
            if (valueQuantity == null || valueQuantity === "") {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna E. La cantidad no es válida.`;
              this.transferAlerts.push(alert);
              rowHasError = true;
            }
            quantity = Number(valueQuantity);
            if (isNaN(quantity)) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna E. La cantidad no es válida.`;
              this.transferAlerts.push(alert);
              rowHasError = true;
            }

            if (!rowHasError) {
              row = new TransferStoreWorkshopDetailImportModel(counter, this.transferStoreWorkshopId,
                consecutiveTransferStoreWorkshop, articleCode, articleName, storeCode, quantity);
              rowsImports.push(row);
            } else {
              isOk = false;
            }
          });

          if (isOk && rowsImports.length > 0) {
            try {
              const response = await firstValueFrom(this.transferStoreWorkshopDetailService.importTransferDetails(rowsImports));
              this.loadPreInvoicingModel = response;
              this.transferAlerts = response?.alerts ?? [];
              this.errorTransfer = response?.preInvoicingStateId;

              if (this.errorTransfer === 1) {
                this.visibleTxt = true;
                this.toastHandlerService.showToast(
                  'error',
                  'La importación terminó con errores, puede exportarlos si lo desea.',
                  'ERROR');
              } else if (this.transferAlerts.length > 0) {
                this.visibleTxt = true;
                this.toastHandlerService.showToast('error', 'La importación terminó con alertas, puede exportarlas si lo desea');
              } else {
                this.transferStoreWorkshopDetailImport = true;
                this.close();
                this.toastHandlerService.showToast('success', `La importación terminó exitosamente.`);
              }
            } catch (error) {
              this.nameFile = 'Ningún archivo seleccionado.';
              console.warn('Ningún archivo seleccionado:', error)
            }
            this.clearInputFile();
          } else {
            this.errorTransfer = 1;
            this.visibleTxt = true;
            this.toastHandlerService.showToast(
              'error',
              'La importación terminó con errores, puede exportarlos si lo desea'
            );
          }
        });
      } else {
        this.toastHandlerService.showToast('warning', `No ha seleccionado ningún archivo.`);
      }
    }
  }
}
